import { eobSchema } from '@billing/validation/eob';
import type { Province } from '@billing/validation/payor';

export interface EOB {
  id: string;
  code: string;
  description: string;
  actionType?: string | null;
  actionDescription?: string | null;
  reviewRequired: boolean;
  province: Province;
}

export type FormEOB = Omit<EOB, 'id'>;

export const isEOB = (obj: unknown): obj is EOB => {
  return eobSchema.safeParse(obj).success;
};
